<template>
    <div>
        <div class="cont">
            <div class="contbox">
                <div class="contboxleft">
                    <div class="title"><em></em><b>{{$t('der7')}}</b></div>
                    <div class="tjcont">
                        <div ref="chart" style="width:100%;height:510px"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import apiurl from "@/api/public"
import _api from "@/api/index"
export default {
    data(){
        return{
            option:{
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                grid: {
                    top:'10%',
                    left: '2.5%',
                    right: '5%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        data: ['12-16', '12-17', '12-18', '12-19', '12-20', '12-21', '12-22'],
                        axisLabel: {      
                            interval:0,
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: this.$t('der8'),
                        type: 'line',
                        smooth: true,
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,[{
                                        offset: 0, color: 'rgba(66, 14, 26,0.6)'
                                    }, {
                                        offset: 0.4, color: 'rgba(66, 14, 26,0.2)'
                                    }, {
                                        offset: 1, color: 'rgba(9, 54, 102,0)'
                                    }]
                                ),
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#471923',
                                label : {
                                    show: false
                                },
                                lineStyle:{
                                    color: '#471923'
                                }
                            }
                        },
                        data: [820, 932, 901, 934, 1290, 1330, 1320]
                    }
                ]
            },
        }
    },
    created() {
        this.getCharts()
    },
    methods:{
        getCharts(){
           _api.get(apiurl.sevenEsDays,{
               accountId: this.$route.query.accountId,
               nation:localStorage.getItem("nation")
           }).then(res => {
               if (res.code==200) {
                   this.option.xAxis[0].data=res.data.dateList
                   this.option.series[0].data=res.data.amountList
                   this.getEchartData()
               }
           })
        },
        getEchartData() {
            const chart = this.$refs.chart
            if (chart) {
                const myChart = this.$echarts.init(chart)
                myChart.setOption(this.option)
                window.addEventListener("resize", function() {
                    myChart.resize()
                })
            }
            this.$on('hook:destroyed',()=>{
                window.removeEventListener("resize", function() {
                    myChart.resize();
                });
            })
        },
    }
}
</script>
<style scoped>
.contbox{ overflow: hidden; display: flex;}
.contboxleft{ flex: 0 0 100%;}
.contboxright{flex: 0 0 100%;}
.title em{ vertical-align: middle; display: inline-block; width: 3px; height:15px; background: #FF7300;}
.title b{ vertical-align: middle; margin-left:8px; font-size: 16px;}
.title a{ float: right; margin-right:20px; font-size: 12px; color: #56a3f3;}
.phcont{ padding:8px 0; padding-right: 25px;}
.phspan{ display: inline-block; color: #ffffff; font-size: 12px; padding:0 7px;  line-height: 20px; height: 20px; text-align: center; border-radius: 10px;}
.spanother{ background: #b9b9b9;}
.span1{ background:#CD012C;}
.span2{ background:#BE4C05;}
.span3{ background:#093666;}
.buttonon{background:rgb(230, 235, 240)!important;color:rgb(9, 54, 102)!important;border:rgb(181, 195, 209) solid 1px!important;}
</style> 